import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_AI_CREDITS_ORDERS } from '../queries/ai_credits';
import { unmarshalGraphqlEdges } from '~graphql/utils';

const DEFAULT_ORDER = ['createdAt_DESC'];

export const fetchAiCreditsOrders = async ({
  limit = 30,
  skip = 0,
  where,
  order = DEFAULT_ORDER,
} = {}) => {
  const graphQlClient = await getGraphQlClient();

  const result = await graphQlClient.query({
    variables: {
      first: limit,
      skip,
      where,
      order,
    },
    query: FETCH_AI_CREDITS_ORDERS,
    fetchPolicy: 'network-only',
  });

  const connection = result?.data?.findRemovebgOrders || {};

  return {
    count: connection.count || 0,
    pageInfo: connection.pageInfo || {},
    edges: unmarshalGraphqlEdges(connection).edges || [],
  };
};

const MAX_FETCH_ALL_PAGES = 50;

export const fetchAllAiCreditsOrders = async ({
  where,
  order = DEFAULT_ORDER,
  batchSize = 200,
} = {}) => {
  const allOrders = [];
  let skip = 0;
  let totalCount = 0;
  let hasNextPage = true;
  let pagesFetched = 0;

  while (hasNextPage && pagesFetched < MAX_FETCH_ALL_PAGES) {
    pagesFetched += 1;

    const nextPage = await fetchAiCreditsOrders({
      limit: batchSize,
      skip,
      where,
      order,
    });

    totalCount = nextPage.count || totalCount;

    if (!nextPage.edges.length) {
      break;
    }

    allOrders.push(...nextPage.edges);
    skip += nextPage.edges.length;
    hasNextPage = Boolean(nextPage.pageInfo?.hasNextPage) && skip < totalCount;
  }

  return allOrders;
};
